import { checkIfSnapshotModeNotificationNeedsToBeReset } from '../helpers'

export let initialState = {
    strategy: {
        keyMarkets: [],
        competitiveLandscape: [],
        strategicImperatives: [],
        _id: '',
        positioningStatement: '',
        product: '',
        indication: '',
        gapLevers: [],
        TPPMimeType: '',
        TPPOriginalFileName: '',
        targetLaunchDate: '',
        TPPS3Name: '',
        organizationId: '',
        createdAt: '',
        updatedAt: '',
        __v: 0,
    },
    valueMessageFilterMapping: '',
    userRecord: {},
    selectedMarket: 'Global',
    gapAnalysisView: 'gapAssessment',
    activitiesTableNumberOfItems: 10,
    evidenceTableNumberOfItems: 10,
    valueMessagesTableNumberOfItems: 10,
    settings: {},
    selectedSharepointFile: {},
    searchResults: [],
    searchQuery: '',
    order: 0,
    autoOpenPanel: {
        type: '',
        data: '',
        isEnabled: false,
    },
    freeTrialStatus: {
        isFreeTrial: false,
        freeTrialStartDate: null,
    },
    snapshotModeNotification: {
        isMinimized: false,
        isAcknowledged: false,
    },
    valueNarratives: {
        viewMode: 'cards',
    },
    isPicoEnabled: false,
    isMaiaEnabled: false,
    tppFilters: {
        hiddenColumnIds: [],
        hiddenRowIds: [],
        hiddenSectionIds: [],
        showContext: false,
    },
    tppFiltersByContext: {},
    commentsViewFilters: {
        hiddenColumnIds: ['updated'],
        filtersState: {
            common: {},
            dateRange: {
                from: null,
                to: null,
            },
            domains: {},
        },
    },
    commentsViewFiltersByContext: {},
    dataTableFilters: {},
}

const getTppFiltersContextIds = (state, strategyOverride) => ({
    organizationId: state?.userRecord?.organizationId,
    userId: state?.userRecord?._id,
    strategyId: strategyOverride?._id ?? state?.strategy?._id,
})

const getTppFiltersForContext = (filtersByContext, { organizationId, userId, strategyId }) => {
    if (!organizationId || !userId || !strategyId) return { ...initialState.tppFilters }
    return filtersByContext?.[organizationId]?.[userId]?.[strategyId] || { ...initialState.tppFilters }
}

const setTppFiltersForContext = (filtersByContext, { organizationId, userId, strategyId }, filters) => {
    if (!organizationId || !userId || !strategyId) return filtersByContext
    return {
        ...filtersByContext,
        [organizationId]: {
            ...(filtersByContext?.[organizationId] || {}),
            [userId]: {
                ...((filtersByContext?.[organizationId] || {})[userId] || {}),
                [strategyId]: filters,
            },
        },
    }
}

const getCommentsDashboardFiltersForContext = (filtersByContext, { organizationId, userId, strategyId }) => {
    if (!organizationId || !userId || !strategyId) return { ...initialState.commentsViewFilters }
    return filtersByContext?.[organizationId]?.[userId]?.[strategyId] || { ...initialState.commentsViewFilters }
}

const setCommentsViewFiltersForContext = (filtersByContext, { organizationId, userId, strategyId }, filters) => {
    if (!organizationId || !userId || !strategyId) return filtersByContext
    return {
        ...filtersByContext,
        [organizationId]: {
            ...(filtersByContext?.[organizationId] || {}),
            [userId]: {
                ...((filtersByContext?.[organizationId] || {})[userId] || {}),
                [strategyId]: filters,
            },
        },
    }
}

export function rootReducer(state = initialState, action) {
    if (action.type === 'SET_STRATEGY') {
        const isSnapshotModeNotificationNeedsToBeReset = checkIfSnapshotModeNotificationNeedsToBeReset(state, action)
        const snapshotModeNotification = isSnapshotModeNotificationNeedsToBeReset
            ? { snapshotModeNotification: { ...initialState.snapshotModeNotification } }
            : {}
        const contextIds = getTppFiltersContextIds(state, action.payload)
        return Object.assign({}, state, {
            strategy: action.payload,
            tppFilters: getTppFiltersForContext(state.tppFiltersByContext, contextIds),
            commentsViewFilters: getCommentsDashboardFiltersForContext(state.commentsViewFiltersByContext, contextIds),
            ...snapshotModeNotification,
        })
    } else if (action.type === 'SET_SNAPSHOT_MODE_NOTIFICATION') {
        return Object.assign({}, state, {
            snapshotModeNotification: {
                isMinimized: action.payload.isMinimized ?? state.snapshotModeNotification.isMinimized,
                isAcknowledged: action.payload.isAcknowledged ?? true,
            },
        })
    } else if (action.type === 'SET_VM_FILTER') {
        return Object.assign({}, state, {
            valueMessageFilterMapping: action.payload,
        })
    } else if (action.type === 'SET_USER_RECORD') {
        const nextState = Object.assign({}, state, {
            userRecord: action.payload,
        })
        const contextIds = getTppFiltersContextIds(nextState)
        return Object.assign({}, state, {
            userRecord: action.payload,
            tppFilters: getTppFiltersForContext(state.tppFiltersByContext, contextIds),
            commentsViewFilters: getCommentsDashboardFiltersForContext(state.commentsViewFiltersByContext, contextIds),
        })
    } else if (action.type === 'SET_SELECTED_MARKET') {
        return Object.assign({}, state, {
            selectedMarket: action.payload,
        })
    } else if (action.type === 'SET_GAP_ANALYSIS_VIEW') {
        return Object.assign({}, state, {
            gapAnalysisView: action.payload,
        })
    } else if (action.type === 'SET_SETTINGS') {
        return Object.assign({}, state, {
            settings: action.payload,
        })
    } else if (action.type === 'SET_VM_TABLE_NUMBER') {
        return Object.assign({}, state, {
            valueMessagesTableNumberOfItems: action.payload,
        })
    } else if (action.type === 'SET_ACTIVITY_TABLE_NUMBER') {
        return Object.assign({}, state, {
            activitiesTableNumberOfItems: action.payload,
        })
    } else if (action.type === 'SET_EVIDENCE_TABLE_NUMBER') {
        return Object.assign({}, state, {
            evidenceTableNumberOfItems: action.payload,
        })
    } else if (action.type === 'SET_ONEDRIVE_FILE') {
        return Object.assign({}, state, {
            selectedSharepointFile: action.payload,
        })
    } else if (action.type === 'SET_SEARCH_RESULTS') {
        return Object.assign({}, state, {
            searchResults: action.payload,
        })
    } else if (action.type === 'SET_SEARCH_QUERY') {
        return Object.assign({}, state, {
            searchQuery: action.payload,
        })
    } else if (action.type === 'LOGOUT') {
        return undefined
    } else if (action.type === 'SET_AUTOOPEN_PANEL') {
        return Object.assign({}, state, {
            autoOpenPanel: action.payload,
        })
    } else if (action.type === 'SET_FREE_TRIAL_STATUS') {
        return Object.assign({}, state, {
            freeTrialStatus: {
                isFreeTrial: action.payload.isFreeTrial,
                freeTrialStartDate: action.payload.freeTrialStartDate,
            },
        })
    } else if (action.type === 'SET_IS_PICO_ENABLED') {
        return Object.assign({}, state, {
            isPicoEnabled: action.payload,
        })
    } else if (action.type === 'SET_IS_MAIA_ENABLED') {
        return Object.assign({}, state, {
            isMaiaEnabled: action.payload,
        })
    } else if (action.type === 'SET_VALUE_NARRATIVES_VIEW_MODE') {
        return Object.assign({}, state, {
            valueNarratives: {
                ...state.valueNarratives,
                viewMode: action.payload,
            },
        })
    } else if (action.type === 'SET_TPP_HIDDEN_COLUMNS') {
        const contextIds = getTppFiltersContextIds(state)
        const updatedFilters = {
            ...state.tppFilters,
            hiddenColumnIds: action.payload,
        }
        return Object.assign({}, state, {
            tppFilters: updatedFilters,
            tppFiltersByContext: setTppFiltersForContext(state.tppFiltersByContext, contextIds, updatedFilters),
        })
    } else if (action.type === 'SET_TPP_HIDDEN_ROWS') {
        const contextIds = getTppFiltersContextIds(state)
        const updatedFilters = {
            ...state.tppFilters,
            hiddenRowIds: action.payload,
        }
        return Object.assign({}, state, {
            tppFilters: updatedFilters,
            tppFiltersByContext: setTppFiltersForContext(state.tppFiltersByContext, contextIds, updatedFilters),
        })
    } else if (action.type === 'SET_TPP_HIDDEN_SECTIONS') {
        const contextIds = getTppFiltersContextIds(state)
        const updatedFilters = {
            ...state.tppFilters,
            hiddenSectionIds: action.payload,
        }
        return Object.assign({}, state, {
            tppFilters: updatedFilters,
            tppFiltersByContext: setTppFiltersForContext(state.tppFiltersByContext, contextIds, updatedFilters),
        })
    } else if (action.type === 'SET_TPP_SHOW_CONTEXT') {
        const contextIds = getTppFiltersContextIds(state)
        const updatedFilters = {
            ...state.tppFilters,
            showContext: action.payload,
        }
        return Object.assign({}, state, {
            tppFilters: updatedFilters,
            tppFiltersByContext: setTppFiltersForContext(state.tppFiltersByContext, contextIds, updatedFilters),
        })
    } else if (action.type === 'RESET_TPP_FILTERS') {
        const contextIds = getTppFiltersContextIds(state)
        const resetFilters = { ...initialState.tppFilters }
        return Object.assign({}, state, {
            tppFilters: resetFilters,
            tppFiltersByContext: setTppFiltersForContext(state.tppFiltersByContext, contextIds, resetFilters),
        })
    } else if (action.type === 'SET_COMMENTS_VIEW_HIDDEN_COLUMNS') {
        const contextIds = getTppFiltersContextIds(state)
        const updatedFilters = {
            ...state.commentsViewFilters,
            hiddenColumnIds: action.payload,
        }
        return Object.assign({}, state, {
            commentsViewFilters: updatedFilters,
            commentsViewFiltersByContext: setCommentsViewFiltersForContext(
                state.commentsViewFiltersByContext,
                contextIds,
                updatedFilters
            ),
        })
    } else if (action.type === 'SET_COMMENTS_VIEW_FILTERS') {
        const contextIds = getTppFiltersContextIds(state)
        const updatedFilters = {
            ...state.commentsViewFilters,
            filtersState: action.payload,
        }
        return Object.assign({}, state, {
            commentsViewFilters: updatedFilters,
            commentsViewFiltersByContext: setCommentsViewFiltersForContext(
                state.commentsViewFiltersByContext,
                contextIds,
                updatedFilters
            ),
        })
    } else if (action.type === 'RESET_COMMENTS_VIEW_FILTERS') {
        const contextIds = getTppFiltersContextIds(state)
        const resetFilters = { ...initialState.commentsViewFilters }
        return Object.assign({}, state, {
            commentsViewFilters: resetFilters,
            commentsViewFiltersByContext: setCommentsViewFiltersForContext(
                state.commentsViewFiltersByContext,
                contextIds,
                resetFilters
            ),
        })
    } else if (action.type === 'SET_DATA_TABLE_FILTERS') {
        const { storageKey, uncheckedByFilterId } = action.payload

        return Object.assign({}, state, {
            dataTableFilters: { ...state.dataTableFilters, [storageKey]: uncheckedByFilterId },
        })
    } else if (action.type === 'CLEAR_STRATEGY') {
        return { ...initialState, dataTableFilters: state.dataTableFilters }
    }

    return state
}
